<template>
  <div>
    <CourseEventsFilter :virtual="true" />
    <CourseEventsList :virtual="true" />
    <div class="text-center">
      <a
        v-if="showMoreEvents"
        class="btn-red"
        href="#"
        @click.prevent="loadMoreEvents"
      >
        {{ $t('show_more_terms') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CourseEventsList from './components/CourseEventsList.vue';
import CourseEventsFilter from './components/CourseEventsFilter.vue';

export default {
  name: 'AppVirtual',
  components: {
    CourseEventsList,
    CourseEventsFilter,
  },
  created() {
    this.setFilterType();
    this.fetchFilterAttributes();
    this.fetchEvents();
  },
  computed: {
    ...mapGetters([
      'showMoreEvents',
    ]),
  },
  methods: {
    fetchFilterAttributes() {
      this.$store.dispatch('fetchFilterAttributes');
    },
    fetchEvents() {
      this.$store.dispatch('loadFirstPageEvents');
    },
    loadMoreEvents() {
      this.$store.dispatch('loadNextPageEvents');
    },
    setFilterType() {
      this.$store.dispatch('setFilterType', 'virtual_or_both');
      this.$store.dispatch('setFilterKind', 'virtual');
    },
  },
};
</script>

<i18n>
{
  "cs": {
    "show_more_terms": "Zobrazit více termínů"
  },
  "sk": {
    "show_more_terms": "Zobraziť viac termínov"
  },
  "en": {
    "show_more_terms": "Show more terms"
  }
}
</i18n>
